//Config const
export const API_URL = process.env.NODE_ENV === 'production' ? 'https://inventario-api.opticasb.co/api' : 'http://localhost:3000/api';

